// The Terminology area: the list of every term, its filters, and the step-by-step translation.
// Kept apart from `terminology.ts`, which is the editor's — the two slices may not share a key.
export default {
	terminologyArea: {
		count: "{shown} of {total} entry | {shown} of {total} entries",
		search: {
			placeholder: "Search terms, synonyms and descriptions…",
		},
		scope: {
			label: "Search in",
			term: "Terms",
			synonyms: "Synonyms",
			description: "Descriptions",
		},
		sort: {
			name: "Name",
			gaps: "Gaps",
		},
		filters: {
			missing: "Missing in",
			missingField: "What is missing",
			fields: {
				term: "Term",
				description: "Description",
			},
			anyLanguage: "Not filtered",
			has: "Has a term in",
			status: {
				label: "Review",
				all: "All",
				needsReview: "Needs review",
				verified: "Verified",
			},
			origin: {
				label: "Show",
				own: "This project",
				withDependencies: "With dependencies",
				overridesOnly: "Own wording only",
			},
			clear: "Clear filters",
		},
		columns: {
			label: "Term",
			origin: "From",
		},
		origin: {
			local: "This project",
			override: "Own wording for “{alias}”",
			dependency: "From “{alias}”",
		},
		showMore: "Show {count} more",
		loadFailed: "The terminology could not be loaded.",
		empty: {
			title: "No terminology yet",
			hint: "Terms are created when you name things in the model — a dataobject, an attribute, a type. There is nothing to add here.",
		},
		noResults: {
			title: "No entries match",
			hint: "Try a different search, or clear the filters.",
		},
		translate: {
			action: "Translate step by step ({count})",
			nothing: "Nothing left to translate in this list",
			title: "Translate step by step",
			note: "Work through the entries that are still missing a translation. Every suggestion is yours to review before it is saved.",
			target: "Translate into",
			progressLabel: "Translation progress",
			progress: "{position} / {total}",
			source: "Translate from",
			suggesting: "Suggesting a translation…",
			gatedNote:
				"Open this entry in the editor, write a description and mark it verified to unlock suggestions. You can still type the translation yourself.",
			suggestAgain: "Suggest again",
			back: "Back",
			skip: "Skip",
			saveNext: "Save & next",
			shortcut: "{keys}Enter saves",
			noSourceLeft:
				"{count} entry has nothing to translate from | {count} entries have nothing to translate from",
			finished: {
				title: "All done",
				skippedTitle: "End of the list",
				nothingTitle: "Nothing to translate",
				nothing:
					"No entry in this list is missing a {language} term that can be translated from another language.",
				translated: "Translated: {count}",
				skipped: "Skipped: {count}",
				reviewSkipped: "Review skipped ({count})",
			},
		},
	},
};
